import { createSelector } from 'reselect';
export var selectChartWidth = state => state.layout.width;
export var selectChartHeight = state => state.layout.height;
export var selectChartCoordinates = createSelector((_state, event) => event, event => {
  return {
    chartX: Math.round(event.pageX - event.currentTarget.offsetLeft),
    chartY: Math.round(event.pageY - event.currentTarget.offsetTop)
  };
});
export var selectContainerScale = state => state.layout.scale;
export var selectMargin = state => state.layout.margin;